import { FlowInstance } from '@workflow/class/flow.service';
import { PageInstance } from '@workflow/class/page.service';

export interface FlowInfo {
  flowId: string;
  pages: PageInstance[];
  configPath: string;
}

/**
 * extract main info from Flow object
 */
export const getFlowInfo = (flow: FlowInstance): FlowInfo => {
  if (flow) {
    return {
      configPath: flow.config?.path || null,
      flowId: flow.id,
      pages: flow.pages
    } as FlowInfo;
  }

  return {} as FlowInfo;
};

export const getFlowInfoForTest = (flow): string => 'test' + flow;
